import { SvgIconProps } from "@mui/material";
import { FC } from "react";

interface StepCircleActiveProps extends SvgIconProps {
  percent?: number;
  baseColor?: string;
}

const radius = 18;

export const StepCircleActive: FC<StepCircleActiveProps> = ({
  percent = 0,
  baseColor = 'var(--blue)',
  stroke = 'var(--white)',
  fill = 'var(--blue)',
  strokeWidth = 2,
  width = 40,
  height = 40,
  ...props
}) => {
  const circumference = 2 * Math.PI * radius + 8;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="20" cy="20" r={radius - 2} fill={fill} />
      {percent && (
        <>
          <circle
            cx="20"
            cy="20"
            r={radius + 1}
            stroke={stroke}
            strokeWidth={strokeWidth}
            fill="none"
          />
          <circle
            cx="20"
            cy="20"
            r={radius + 1}
            stroke={baseColor}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform="rotate(-90 20 20)"
          />
        </>
      )}
    </svg>
  );
};
